export const taskPriorityOptions = [
    { value: 'urgent', label: 'Urgent' },
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
];

export const leaveOptions = [
    { label: "Sick Leave", value: "SL" },
    { label: "Earned Leave", value: "EL" },
    { label: "Casual Leave", value: "CL" },
    { label: "Comp Off", value: "COFF" },
    { label: "Early Punch Out Leave", value: "EPOL" },
];